import React from "react";
import Header from "../../Header1";
import Footer from "../../Footer1";
import Title from "./Title";
import Privacy from "./Privacy";

const PrivacyPolicy = () => {
	return (
		<>
			<Header />
			<Title />
			<Privacy />
			<Footer />
		</>
	);
};
export default PrivacyPolicy;
